import React from 'react'
import { Button, Input, Label, Modal } from '@/shared/ui'
import { useToast } from '@/shared/ui/Toast'
import type { FinanceCostCategory } from '../../services/financeCostsService'
import { upsertFinanceCostCategory } from '../../services/financeCostsService'

type Props = {
  open: boolean
  onClose: () => void
  onSaved: () => void
  initial?: FinanceCostCategory | null
}

export function FinanceCostCategoryModal({ open, onClose, onSaved, initial }: Props) {
  const { add: toast } = useToast()
  const [name, setName] = React.useState(initial?.name || '')
  const [saving, setSaving] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!open) return
    setName(initial?.name || '')
    setSaving(false)
    setError(null)
  }, [open, initial])

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    try {
      setSaving(true)
      await upsertFinanceCostCategory({ id: initial?.id, name })
      toast({ title: 'Categoria salva', description: name.trim(), variant: 'success', soft: true })
      onSaved()
      onClose()
    } catch (e: any) {
      setError(e?.message || 'Falha ao salvar categoria')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal open={open} onOpenChange={(v) => { if (!v) onClose() }}>
      <div className="mb-4">
        <h2 className="text-lg font-medium">{initial?.id ? 'Editar categoria' : 'Nova categoria'}</h2>
      </div>
      <form onSubmit={onSubmit} className="space-y-4">
        {error && <div className="text-sm text-red-400">{error}</div>}
        <div className="space-y-1.5">
          <Label>Nome</Label>
          <Input value={name} onChange={(e) => setName((e.target as HTMLInputElement).value)} placeholder="Ex.: Publicidade" />
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</Button>
        </div>
      </form>
    </Modal>
  )
}
